module.exports = __webpack_public_path__ + "static/img/logo2.cb61863d.png";